<template>
  <v-dialog :value="value" @input="(v) => $emit('input', v)" width="640">
    <v-card class="tw-p-8">
      <v-card-title class="tw-font-bold tw-p-0">
        เพิ่มช่องทางการเชื่อมต่อ
      </v-card-title>

      <v-card-text class="tw-p-0 my-8">
        <v-form ref="form" v-model="formValid">
          <v-text-field
            name="channelName"
            label="ชื่อช่องทางการเชื่อมต่อ (ภาษาไทย)*"
            v-model="formData.nameTH"
            :rules="formRules.required"
            outlined
            required
          ></v-text-field>

          <v-text-field
            name="channelName"
            label="ชื่อช่องทางการเชื่อมต่อ (ภาษาอังกฤษ)*"
            v-model="formData.nameEN"
            :rules="formRules.required"
            outlined
            required
          ></v-text-field>

          <div class="channel-selection">
            <div class="tw-text-black">เลือกช่องทางการเชื่อมต่อ</div>
            <v-row align="center">
              <v-col sm="4" cols="12" v-for="ch in channels" :key="ch">
                <v-btn
                  class="tw-shadow-md"
                  :class="{ selected: ch === formData.channelType }"
                  color="white"
                  @click="onSelectChannel(ch)"
                >
                  <shop-channel-icon :channelType="ch" :width="150" :isLarge="true" />
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions class="tw-mt-8 tw-p-0">
        <v-spacer></v-spacer>
        <v-btn
          class="tw-ml-3"
          color="primary"
          text
          :loading="loading"
          @click="onCreate()"
        >
          <v-icon left>mdi-plus-circle-outline</v-icon>
          สร้างช่องทางการเชื่อมต่อ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ShopChannelIcon from './shop-channel-icon.vue'

const DEFAULT_FORM = {
  channelType: 1,
  nameEN: '',
  nameTH: '',
}

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      required: true,
    },
    shopId: {
      type: String,
      required: true,
    },
  },
  components: {
    ShopChannelIcon,
  },
  data: () => ({
    channels: [1, 2],
    formData: { ...DEFAULT_FORM },
    formValid: false,
    formRules: {
      required: [v => !!v]
    },
    loading: false,
  }),
  methods: {
    onSelectChannel(ch) {
      this.formData.channelType = ch
    },
    reset() {
      this.formData = { ...DEFAULT_FORM }
    },
    async onCreate() {
      if(!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      console.log({
          companyId: this.companyId,
          shopId: this.shopId,
          channel: this.formData,
        })
      try {
        const id = await this.$store.dispatch('shopChannels/save', {
          companyId: this.companyId,
          shopId: this.shopId,
          channel: this.formData,
        })
        this.$emit('input', false)
        this.$emit('success', id)
        this.loading = false
      } catch (err) {
        console.error(err)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-selection {
  button {
    height: auto !important;
    width: 100%;
  }

  button.selected {
    border: #6ec39b solid 2px !important;
  }

  img {
    margin: 18px;
    height: 30px;
    width: auto;
  }
}
</style>